var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNot = function SvgNot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61 12.39a1.68 1.68 0 0 1-.43 1.13A1.51 1.51 0 0 1 7 14a1.51 1.51 0 0 1-1.18-.48 1.7 1.7 0 0 1 0-2.26A1.51 1.51 0 0 1 7 10.78a1.51 1.51 0 0 1 1.18.48 1.68 1.68 0 0 1 .43 1.13ZM8 9.55H6L5.6 0h2.8Z"
  })));
};

export default SvgNot;